"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const blockFilterState_1 = __importDefault(require("@/common/components/NavHeader/blockFilterState"));
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const detect_utils_1 = require("@/common/detect_utils");
const RoomCard_1 = require("@/common/components/RoomCard");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
function default_1() {
    const { ready: isBlockFilterReady, blockFilter } = (0, recoil_1.useRecoilValue)(blockFilterState_1.default);
    const isBlockFilterAvailable = !!blockFilter;
    const [hotLikeData, setHotLikeData] = (0, react_1.useState)([]);
    const isDataAvailable = !!hotLikeData.length;
    (0, react_1.useEffect)(() => {
        if (isBlockFilterReady && !isDataAvailable) {
            (0, api_1.getData)(`${detect_utils_1.fondeeSearchOrigin}/api/v1/fondee/room?type=hot-like&size=4${isBlockFilterAvailable ? `&filter=${blockFilter}` : ''}`)
                .then(res => setHotLikeData(res.data))
                .catch(() => { });
        }
    }, [isBlockFilterReady]);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const maxWidth896 = (0, useMediaQuery_1.default)('(max-width:896px)');
    const maxWidth1024 = (0, useMediaQuery_1.default)('(max-width:1024px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    const dataSize = maxWidth896 ? 3 : 4;
    const initialSkeletonArr = new Array(dataSize).fill('skeleton');
    if (maxWidth768)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '20px',
            paddingLeft: maxWidth1024 ? '11px' : 0,
        } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle2 gray-80" }, { children: t('오늘의 인기 작품') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                    display: 'grid',
                    gridTemplateColumns: `repeat(${dataSize}, 1fr)`,
                    gap: '20px 10px',
                } }, { children: isDataAvailable
                    ? hotLikeData
                        .slice(0, dataSize)
                        .map((roomData, index) => ((0, jsx_runtime_1.jsx)(RoomCard_1.RoomCardA, { roomData: roomData, changeLikeStateFn: () => { }, maxWidth768: maxWidth768, isHotLike: true, useFondeeSearchApi: true }, `hot_like_${index}`)))
                    : initialSkeletonArr.map((_, index) => ((0, jsx_runtime_1.jsx)(RoomCard_1.RoomCardSkeleton, { maxWidth768: maxWidth768 }, `hot_like_skeleton_${index}`))) }))] })));
}
exports.default = default_1;
